var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 306 306"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F2F0",
    d: "M305.319 152.769c0 84.191-68.25 152.441-152.441 152.441-84.19 0-152.44-68.25-152.44-152.441 0-84.19 68.25-152.44 152.44-152.44 84.191 0 152.441 68.25 152.441 152.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M152.878 297.324c79.836 0 144.555-64.72 144.555-144.555 0-79.835-64.719-144.555-144.555-144.555-79.835 0-144.554 64.72-144.554 144.555 0 79.835 64.719 144.555 144.554 144.555Zm0 7.886c84.191 0 152.441-68.25 152.441-152.441 0-84.19-68.25-152.44-152.441-152.44C68.688.328.438 68.578.438 152.768c0 84.191 68.25 152.441 152.44 152.441Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FADC86",
    d: "m182.188 104.451 18.994 18.994-82.456 82.457-18.994-18.995z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "m192.836 93.8 18.994 18.995-10.65 10.65-18.995-18.994z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD8D9C",
    d: "m203.484 83.15 18.995 18.994-10.65 10.65-18.995-18.993z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m92.814 212.929 6.96-25.978 19.017 19.017-25.977 6.961Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m92.813 212.928 1.948-7.274 5.325 5.325-7.273 1.949Z"
  })));
};
export default SvgPencil;